import LandingNav from "./LandingNav";
import HeroSection from "./HeroSection";
import SocialProofStrip from "./SocialProofStrip";
import ValuePillars from "./ValuePillars";
import LiveDebatePreview from "./LiveDebatePreview";
import AgentRoster from "./AgentRoster";
import HowItWorks from "./HowItWorks";
import RoadmapTeaser from "./RoadmapTeaser";
import VaultTeaser from "./VaultTeaser";
import HitlSection from "./HitlSection";
import FaqSection from "./FaqSection";
import FinalCta from "./FinalCta";
import LandingFooter from "./LandingFooter";

export default function LandingPage() {
  return (
    <div
      data-testid="landing-page"
      className="min-h-screen bg-[#F7F7F5] text-zinc-900 antialiased"
    >
      <LandingNav />
      <main>
        <HeroSection />
        <SocialProofStrip />
        <ValuePillars />
        <LiveDebatePreview />
        <AgentRoster />
        <HowItWorks />
        <RoadmapTeaser />
        <VaultTeaser />
        <HitlSection />
        <FaqSection />
        <FinalCta />
      </main>
      <LandingFooter />
    </div>
  );
}
